import React from "react";
import { format } from "date-fns";
import { fullDateLongFormat } from "@common/helpers/date";
import { FiltersTypes } from "@common/types/filters/general";

interface Props {
    filters: FiltersTypes;
}

export const ApplicationDateFilterLabel: React.FC<Props> = ({ filters }) => {
    const { applicationDateStart, applicationDateEnd } = filters;

    if (!applicationDateStart && !applicationDateEnd) {
        return null;
    }

    if (applicationDateStart && applicationDateEnd) {
        return (
            <span>
                {format(applicationDateStart, fullDateLongFormat)} -{" "}
                {format(applicationDateEnd, fullDateLongFormat)}
            </span>
        );
    }

    if (applicationDateStart) {
        return (
            <span>From {format(applicationDateStart, fullDateLongFormat)}</span>
        );
    }

    if (applicationDateEnd) {
        return (
            <span>Until {format(applicationDateEnd, fullDateLongFormat)}</span>
        );
    }

    return null;
};
